module.exports = "/_next/static/images/qna-bg--secondary6-a8fd0cee368f181edcfc76c7402fe3c5.png";